export default __webpack_public_path__ + "static/media/section2_1.fc28f3bc.png";